import { useAtomValue } from 'jotai';
import usePdpLastSelectedOptionIdAtom from './usePdpLastSelectedOptionIdAtom';
const usePdpLastSelectedOptionId = () => {
  const pdpLastSelectedOptionIdAtom = usePdpLastSelectedOptionIdAtom();
  const pdpLastSelectedOptionId = useAtomValue(pdpLastSelectedOptionIdAtom);
  return pdpLastSelectedOptionId;
};
export default usePdpLastSelectedOptionId;